import { includes } from 'lodash';
import React from 'react';
import { Form } from '@ant-design/compatible';
import cx from 'classnames';
import { connect } from 'react-redux';
import { ENABLE_SEARCH_WIDGET_BANNER_ITEM_LINK_TYPE_LIST } from '../../../constants/service/app/widgetConstants';
import { APP_LINK_TYPE } from '../../../constants/service/common/commonConstants';
import { appActions } from '../../../store/modules/app';
import { widgetActions } from '../../../store/modules/widget';
import GlobalLink from '../../GlobalLink/GlobalLink';
import { REQUIRED_MSG } from '../../../constants/service/common/formRulesConstants';

const GlobalLinkForm = (props) => {
  const {
    form,
    label,
    list,
    rules,
    name,
    initialValue,
    className,
    getValueFromEvent,
    vertical = false,
    ...res
  } = props;
  const { getFieldDecorator } = form;

  const validateLink = (rule, value, callback) => {
    if (!value.linkType) {
      return callback(REQUIRED_MSG);
    }
    if (includes(ENABLE_SEARCH_WIDGET_BANNER_ITEM_LINK_TYPE_LIST, value.linkType) && !value.linkId) {
      return callback(
        "링크 종류가 '브랜드 상세 페이지', '기획전 상세 페이지', '상품 상세 페이지', '후기 상세', '태그 상세 - 갤러리', '태그 상세 - 피드', '홈 페이지'인 경우에는 링크 ID 를 반드시 설정하셔야 합니다.",
      );
    }
    if (includes([APP_LINK_TYPE.WEB_PAGE, APP_LINK_TYPE.CATEGORY_PAGE], value.linkType) && !value.linkUrl) {
      return callback("링크 종류가 ‘웹페이지' 인 경우에는 URL을 반드시 입력하셔야 합니다.");
    }

    callback();
  };

  /**
   * required가 true일때 커스텀된 link 전용 validator를 적용
   */
  const processedRules =
    rules && rules.length > 0 && rules[0].required
      ? [{ ...rules[0], type: 'object', validator: validateLink }, ...rules.slice(1)]
      : rules;

  return (
    <div className={className}>
      <Form.Item className={cx('select-form', 'amondz-form', { 'with-label': label }, { vertical })} label={label}>
        {getFieldDecorator(name, {
          initialValue,
          rules: processedRules,
          getValueFromEvent,
        })(<GlobalLink list={list} {...res} />)}
      </Form.Item>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    tempModalData: state.widget.tempModalData,
  };
};

const mapDispatchToProps = {
  appToggleModal: appActions.appToggleModal,
  toggleModal: widgetActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalLinkForm);
